<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
    <div class="dialog-content-container">
        <app-select-input [label]="'Who is the person that has commited an offence?'" shortLabel="Person" [control]="crimeDetailsForm.controls.person" [options]="personOptions" placeholder="Select a Person">
        </app-select-input>
   
        <app-text-input label="What was the offence?" shortLabel="Offence" [control]="crimeDetailsForm.controls.offence">
        </app-text-input>

    
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="ok()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
